import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import {
  AddResourceGroupParams,
  EditResourceGroupParams, ResourceGroup,
  ResourceGroupParams,
  ResourceGroupWithPage,
} from '@app/interfaces/rm/resource-group';
import { lastValueFrom } from 'rxjs';
import { SelectOption } from '@app/interfaces/sys/dict';

@Injectable({
  providedIn: 'root'
})
export class ResourceGroupService {
  private baseUrl = environment.api.services.rm + '/resource-instance-groups';

  constructor(private http: HttpClient) { }

  async find(params: ResourceGroupParams): Promise<ResourceGroupWithPage> {
    return lastValueFrom(this.http.get<ResourceGroupWithPage>(`${this.baseUrl}`, {
      params: Object.assign(params),
    }));
  }

  async one(id: number): Promise<ResourceGroup> {
    return lastValueFrom(this.http.get<ResourceGroup>(`${this.baseUrl}/one`, {
      params: Object.assign({
        id
      }),
    }));
  }

  async getOptions(): Promise<SelectOption[]> {
    return lastValueFrom(this.http.get<SelectOption[]>(`${this.baseUrl}/all-options`));
  }

  async add(data: AddResourceGroupParams): Promise<void> {
    return lastValueFrom(this.http.post<void>(`${this.baseUrl}`, data));
  }

  async edit(data: EditResourceGroupParams): Promise<void> {
    return lastValueFrom(this.http.put<void>(`${this.baseUrl}`, data));
  }

  async remove(id: number): Promise<void> {
    return lastValueFrom(this.http.delete<void>(`${this.baseUrl}`, {
      params: Object.assign({ id }),
    }));
  }
}
